export default () =>
  import(/* webpackChunkName: 'coffee/activities/medal-ranking/home' */ './Home');
